import React from 'react';
import { Platform, ViewStyle } from 'react-native';
import { Button as Base } from 'react-native-paper';
import styled from 'styled-components/native';

import {
  backgroundColorGetter,
  labelColorGetter,
  rippleColorGetter,
} from './helpers';
import { Props } from './types';

const isAndroid = Platform.OS === 'android';

const StyledButton = styled(Base).attrs<Props>(
  ({
    theme,
    variant = 'body',
    level = 1,
    mode,
    preset = 'primary',
    width = null,
  }) => ({
    uppercase: false,
    color: rippleColorGetter(preset, theme),
    labelStyle: {
      fontFamily: isAndroid
        ? theme.fonts.bold.fontFamily
        : theme.fonts.medium.fontFamily,
      fontSize: theme.typography[variant][level].fontSize,
      fontWeight: isAndroid ? 'normal' : 'bold',
      lineHeight: theme.typography[variant][level].lineHeight,
      color: labelColorGetter(preset, theme, mode),
    },
    contentStyle: {
      backgroundColor: backgroundColorGetter(preset, theme),
      borderWidth: mode === 'outlined' ? 2 : 0,
      borderRadius: mode === 'outlined' ? 12 : 0,
      borderColor:
        mode === 'outlined'
          ? labelColorGetter(preset, theme, mode)
          : theme.colors.transparent,
      height: 52,
      width: width,
    } as ViewStyle,
  })
)<Props>`
  margin: 1px;
`;

const Button: React.FC<Props> = (props) => {
  const { mode, variant, preset, level, children, theme, ...rest } = props;

  return (
    <StyledButton
      mode={mode}
      variant={variant}
      preset={preset}
      level={level}
      theme={theme as any}
      {...rest}
    >
      {children}
    </StyledButton>
  );
};

export default Button;
export type { Props };
